<template lang="pug">
  v-row
    v-col(cols="12")
      h1 Задания
    v-col(cols="12")
      v-slide-y-reverse-transition(mode="out-in")
        div(v-if="loading" class="text-center" key="loader")
          v-progress-circular(size="70" color="primary" indeterminate)
        v-data-table(
          v-if="!loading"
          class="my-courses-table"
          :items="courses"
          :headers="headers"
          key="table"
        )
          template(v-slot:item.status="{ item }")
            span {{ item.status.text }}
          template(v-slot:item.title="{ item }")
            router-link(
              :to=`{
                name: 'CourseView',
                params: { id: item.id }
              }`
            ) {{ item.title }}
          template(v-slot:item.tasks="{ item }")
            v-btn(
              :to=`{
                name: 'TaskListForPass',
                params: { courseId: item.id, groupId: item.user_group_id }
              }`
            ) Задания
          template(v-slot:item.finished="{ item }")
            v-progress-circular.my-2(
              :rotate="270"
              :size="70"
              :width="10"
              :value="item.progress"
              color="success"
            ) {{item.progress}}%
            v-tooltip(v-if="false" left)
              template(v-slot:activator="{ on, attrs }")
                div(v-on="on")
                  corona-icon(:complete="item.finished")
              span Пройдено {{ item.finished }} из {{ 100 }}

</template>

<script>
import { mapGetters } from 'vuex';
import CourseService from '@/services/API/CourseService';
import CoronaIcon from '@/components/Icons/CoronaIcon.vue';

export default {
  name: 'StudentsCourseList',
  components: {
    CoronaIcon,
  },
  data: () => ({
    courses: [],
    loading: true,
    headers: [
      { text: 'Наименование', value: 'title' },
      { text: 'Задания', value: 'tasks' },
      { text: 'Объем курса', value: 'duration' },
      { text: 'Пройдено', value: 'finished' },
    ],
  }),
  computed: {
    ...mapGetters({ userData: 'auth/userData' }),
  },
  mounted() {
    this.getCourseList();
  },
  methods: {
    getCourseList() {
      const params = {
        'search[contracted_or_requested]': true,
        expand: 'user_group_id',
      };
      this.loading = true;
      params['search[trained]'] = true;

      CourseService.getCourseList({ ...params })
        .then((r) => {
          this.courses = r.data.data;
          // this.courses.forEach((c) => {
          //   this.$set(c, 'finished', Math.floor(Math.random() * 100));
          // });
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
  .v-data-table.my-courses-table td,
  .v-data-table.my-courses-table th {
    font-size: 0.95rem;
  }

  .v-data-table.my-courses-table tbody {
    tr:hover {
      background-color: transparent !important;
    }
  }

</style>
